import React, { useCallback, useRef, useState } from 'react'
import {
    createColumnHelper,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable
} from '@tanstack/react-table'
import TableListing from '../../components/TableListing/TableListing'
import requestApi from '../../utils/request'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import Pagination from '../../components/Pagination'
import { useForm } from 'react-hook-form'
import { useEffect } from 'react'
import DeleteModal from '../../components/DeleteModal/DeleteModal'
import Swal from 'sweetalert2'
import ApproveDeclinePopup from '../../components/ApproveDeclinePopup/ApproveDeclinePopup'
import { useNavigate } from 'react-router-dom'
import TableSkeleton from '../../components/TableSkeleton/TableSkeleton'
import AddEditModal from '../../components/AddEditModal/AddEditModal'
import InputControl from '../../components/InputControl'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

import { ReactComponent as IconsDots } from '../../assets/images/icons/icon-action-dots.svg'
import { ReactComponent as IconEdit } from '../../assets/images/icons/icon-edit-white.svg'
import { ReactComponent as IconDelete } from '../../assets/images/icons/icon-delete-white.svg'
import { ReactComponent as IconRejected } from '../../assets/images/icons/icon-rejected-status.svg'
import { ReactComponent as IconApproveRight } from '../../assets/images/icons/icon-right-aprrove.svg'
import { ReactComponent as IconDesapproveClose } from '../../assets/images/icons/icon-close-desaprrove.svg'

const validationSchemaForCategory = yup.object({
    mainCategoryName: yup.string().required('Please enter cateogry name')
})

const CategoryManagement = () => {
    const [toastshow, setToastshow] = useState(false)

    const queryClient = useQueryClient()
    const navigate = useNavigate()
    const [DataLimit, setDataLimit] = useState(10)
    const [columnVisibility, setColumnVisibility] = React.useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [userFilterText, setuserFilterText] = useState('')
    const [sorting, setSorting] = useState([])
    const [filter, setFilter] = useState(null)
    const [searchKeyword, setSearchKeyword] = useState('')
    const [isDeleteModal, setIsDeleteModal] = useState(false)

    const [ShowMaterialStatusPopup, setShowMaterialStatusPopup] =
        useState(false)
    const [statusUpdate, setStatusUpdate] = useState(null)
    const [buttonText, setButtonText] = useState('')

    const [mainCategory, setmainCategory] = useState('')

    const [deleteId, setDelteId] = useState('')
    const EditDataRef = useRef(null)

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm()

    const handleSearch = useCallback((e) => {
        setCurrentPage(1)
        const getData = setTimeout(() => {
            setSearchKeyword(e.target.value)
        }, 1000)
        clearInterval()
    }, [])
  
    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    const handleChange3 = (e) => {
        setmainCategory(e.target.value)
    }

    const handleChange = (eventkey) => {
        setDataLimit(eventkey)
    }

    const [openAction, setopenAction] = useState(null)
    const OpenAction = (id) => {
        setopenAction(openAction === id ? null : id)
    }

    function UserList({ queryKey }) {
        return requestApi
            .post(
                `main-category/list`,
                {
                    search: queryKey[3],
                    limit: queryKey[2],
                    page: queryKey[1],
                    sortKey: queryKey[4]?.sortKey,
                    sortBy: queryKey[4]?.sortBy,
                    mainCategory
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }

    const { data, isLoading } = useQuery({
        queryKey: [
            'categorylist',
            currentPage,
            DataLimit,
            searchKeyword,
           filter
        ],
        queryFn: UserList
    })

    useEffect(() => {
        if (currentPage && data?.data?.length === 0) {
            setCurrentPage(currentPage - 1)
        } else {
        }
    }, [currentPage, data?.data])

    useEffect(() => {
        setCurrentPage(1)
    }, [searchKeyword])

    //#region Table Columns
    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.accessor((row) => row?.name, {
            id: 'name',
            header: () => 'Category'
        }),
        columnHelper.accessor((row) => row?.status, {
            id: 'status',
            header: () => 'Status',
            enableSorting: false,
            cell: (row) => {
                switch (row?.row?.original?.status) {
                    case 7:
                        return (
                            <span className="pending-data status-data">
                                Pending
                            </span>
                        )
                    case 5:
                        return (
                            // <span className="decline-data status-data">
                            //     Decline
                            // </span>
                            <span class="rejected-status status-data">
                                <IconRejected /> Rejected
                            </span>
                        )

                    default:
                        return (
                            <>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        checked={
                                            row?.row?.original?.status == 1
                                                ? true
                                                : false
                                        }
                                        onChange={(e) =>
                                            onStatusChange(
                                                row?.row?.original?._id
                                            )
                                        }
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </>
                        )
                }
            }
        }),
        columnHelper.display({
            id: 'actions',
            header: () => 'Actions',
            cell: (row) => {
                switch (row.row.original.status) {
                    case 7:
                        return (
                            <>
                                <div
                                    className={`table-action ${
                                        row?.row?.original?._id === openAction
                                            ? 'active'
                                            : ''
                                    }`}
                                    onMouseLeave={() => setopenAction(null)}
                                >
                                    <div
                                        className={`action-btn ${
                                            row?.row?.original?._id ===
                                            openAction
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() =>
                                            OpenAction(row?.row?.original?._id)
                                        }
                                    >
                                        <IconsDots />
                                    </div>
                                    <div className="action-panel two-action">
                                        <div
                                            className="action-btn-icon edit"
                                            onClick={() => {
                                                handleApproveDecline(
                                                    row?.row?.original?._id,
                                                    setButtonText('Approve')
                                                )
                                            }}
                                        >
                                            <IconApproveRight />
                                        </div>
                                        <div
                                            className="action-btn-icon delete"
                                            onClick={() => {
                                                handleApproveDecline(
                                                    row?.row?.original?._id,
                                                    setButtonText('Decline')
                                                )
                                            }}
                                        >
                                            <IconDesapproveClose />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )

                    case 5:
                        return <>-</>

                    default:
                        return (
                            <div
                                className={`table-action ${
                                    row?.row?.original?._id === openAction
                                        ? 'active'
                                        : ''
                                }`}
                                onMouseLeave={() => setopenAction(null)}
                            >
                                <div
                                    className={`action-btn ${
                                        row?.row?.original?._id === openAction
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        OpenAction(row?.row?.original?._id)
                                    }
                                >
                                    <IconsDots />
                                </div>
                                <div className="action-panel two-action">
                                    <div
                                        className="action-btn-icon edit"
                                        onClick={() =>
                                            handleAddEditModal(
                                                row?.row?.original
                                            )
                                        }
                                    >
                                        <IconEdit />
                                    </div>
                                    <div
                                        className="action-btn-icon delete"
                                        onClick={() =>
                                            handleDeleteModal(
                                                row?.row?.original?._id
                                            )
                                        }
                                    >
                                        <IconDelete />
                                    </div>
                                </div>
                            </div>
                        )
                }
            }
        })
    ]
    //#endregion

    const table = useReactTable({
        data: data?.data,
        columns: columns,
        // onSortingChange: setSorting,
        state: {
            columnVisibility,
          },
          onColumnVisibilityChange: setColumnVisibility,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    //#region delete Category
    const handleDeleteModal = (id) => {
        setIsDeleteModal(true)
        setDelteId(id)
    }

    function handleDelete(mainCategoryId) {
        mutationDelete.mutate(mainCategoryId)
        setIsDeleteModal(false)
    }
    async function deletecategoryId(mainCategoryId) {
        return await requestApi.post(`main-category/delete`, {
            mainCategoryId
        })
    }

    const mutationDelete = useMutation(deletecategoryId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('categorylist')
            setIsDeleteModal(false)
            EditDataRef.current = null
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            })
        },
        onError: () => {
            EditDataRef.current = null
        }
    })
    //#endregion

    //#region approve type status
    const handleApproveDecline = (id) => {
        setShowMaterialStatusPopup(true)
        setStatusUpdate(id)
    }

    function handlePermission(mainCategoryId) {
        mutationStatusUpdate.mutate(mainCategoryId)
        setShowMaterialStatusPopup(false)
    }

    async function updateStatusbyId(mainCategoryId) {
        if (buttonText == 'Approve') {
            return await requestApi.post(`/main-category/approve-decline`, {
                mainCategoryId,
                status: 1
            })
        } else {
            return await requestApi.post(`/main-category/approve-decline`, {
                mainCategoryId,
                status: 5
            })
        }
    }

    const mutationStatusUpdate = useMutation(updateStatusbyId, {
        onSuccess: ({ data }) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: data?.meta?.message
            })
            queryClient.invalidateQueries('categorylist')
            setShowMaterialStatusPopup(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })

    //#endregion

    //#region  Active/InActive Status Update
    const onStatusChange = useCallback((mainCategoryId) => {
        mutationStatusActiveInactive.mutate(mainCategoryId)
    }, [])
    async function updateStatusbycategoryId(mainCategoryId) {
        return await requestApi.post(`/main-category/active-inactive-status`, {
            mainCategoryId
        })
    }
    const mutationStatusActiveInactive = useMutation(updateStatusbycategoryId, {
        onSuccess: ({ data }) => {
            // Swal.fire({
            //     position: 'center',
            //     icon: 'success',
            //     title: '',
            //     text: data?.meta?.message
            // })
            queryClient.invalidateQueries('colorlist')
            setShowMaterialStatusPopup(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    //#endregion

    //#region Modal for AddEdit
    const [AddEditShow, setAddEditShow] = useState(false)
    const [categoryID, setCategoryID] = useState('')

    const handleAddEditModal = (data) => {
        setAddEditShow(true)
        const { name, _id } = data
        msetValue('mainCategoryName', name)
        setCategoryID(_id)
    }
    const handleAddEditModalForNew = () => {
        setAddEditShow(true)
        setCategoryID(null)
        msetValue('mainCategoryName', null)
    }

    const {
        register: mregister,
        handleSubmit: mhandleSubmit,
        formState: { errors: merrors },
        reset: mreset,
        setValue: msetValue
    } = useForm({
        mode: 'onChange',
        resolver: yupResolver(validationSchemaForCategory)
    })
    //#endregion

    return (
        <div
            className="categories-management"
            id="Listing_category"
            name="listing_cateogry"
            aria-label="listing_cateogry"
        >
            <div className="admin-card">
                <div class="head">
                    <h2>Category Management</h2>
                    <div className="search-btn-group">
                        <form
                            action=""
                            {...register('categorySearch', {
                                onChange: (e) => {
                                    handleSearch(e)
                                }
                            })}
                            className="product-table-filter"
                        >
                            <input
                                type="search"
                                name="categorySearch"
                                placeholder="Search"
                            />
                        </form>
                        <button
                            className="solid-red-btn"
                            onClick={() => handleAddEditModalForNew()}
                        >
                            Add New Category{' '}
                        </button>
                    </div>
                </div>
                {isLoading ? (
                    <TableSkeleton />
                ) : data?.data?.length > 0 ? (
                    <>
                        <TableListing table={table} className="m-0" getfilter={(e) => {setFilter(e)}} />
                       
                        <div className="pagination-wrap">
                            <div className="showing-pages">
                                <span>
                                    Showing {(currentPage - 1) * DataLimit + 1}{' '}
                                    to{' '}
                                    {Math.min(
                                        currentPage * DataLimit,
                                        data.meta.totalCount
                                    )}{' '}
                                    of {data.meta.totalCount}{' '}
                                    {data.meta.totalCount > 1
                                        ? ' categories'
                                        : ' category'}
                                </span>
                            </div>

                            {data?.meta?.totalCount > 10 && (
                                <>
                                    {/* <div className="itemperpage-box">
                                            <span>Items per page:</span>
                                            <Dropdown
                                                flip="no"
                                                onSelect={handleChange}
                                            >
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                >
                                                    {DataLimit}
                                                </Dropdown.Toggle>
    
                                                <Dropdown.Menu>
                                                    <Dropdown.Item eventKey="10">
                                                        10
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="20">
                                                        20
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="30">
                                                        30
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div> */}

                                    <Pagination
                                        total={Math.ceil(
                                            data.meta.totalCount / DataLimit
                                        )}
                                        current={currentPage}
                                        onChangePage={handleChangePage}
                                    />
                                </>
                            )}
                        </div>
                    </>
                ) : (
                    <div className="no-record-found">No Record Found</div>
                )}
                <DeleteModal
                    message={
                        <>
                            Are you sure you want to delete <br />
                            this category ?
                        </>
                    }
                    setIsDeleteModal={setIsDeleteModal}
                    isDeleteModal={isDeleteModal}
                    handleDelete={() => handleDelete(deleteId)}
                />
                <ApproveDeclinePopup
                    ShowMaterialStatusPopup={ShowMaterialStatusPopup}
                    setShowMaterialStatusPopup={setShowMaterialStatusPopup}
                    setStatusUpdate={statusUpdate}
                    title={`Are you sure you want to ${buttonText} ?`}
                    // handlestatus={handlestatus}
                    text={buttonText}
                    handlePermission={() => handlePermission(statusUpdate)}
                />

                {/* AddEdit Modal Start */}
                <AddEditModal
                    AddEditShow={AddEditShow}
                    setAddEditShow={setAddEditShow}
                    handleClose={() => setAddEditShow(false)}
                >
                    <Child
                        register={mregister}
                        handleSubmit={mhandleSubmit}
                        errors={merrors}
                        reset={mreset}
                        setValue={msetValue}
                        categoryID={categoryID}
                        setCategoryID={setCategoryID}
                        setAddEditShow={setAddEditShow}
                        queryClient={queryClient}
                        setToastshow={setToastshow}
                        toastshow={toastshow}
                    />
                </AddEditModal>
                {/* AddEdit Modal End */}
            </div>
        </div>
    )
}

export default CategoryManagement

//#region  Modal child Component
const Child = ({
    register,
    handleSubmit,
    errors,
    reset,
    setValue,
    categoryID,
    setCategoryID,
    setAddEditShow,
    queryClient,
    setToastshow,
    toastshow
}) => {
    async function mainCategoryAddEdit(payload) {
        if (categoryID) {
            return await requestApi
                .post(`main-category/add-edit`, {
                    mainCategoryId: categoryID,
                    ...payload
                })
                .then((res) => {
                    return res.data
                })
        } else {
            return await requestApi
                .post(`main-category/add-edit`, payload)
                .then((res) => {
                    return res.data
                })
        }
    }

    const mutation = useMutation(mainCategoryAddEdit, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            }).then(() => {
                setAddEditShow(false)
                setCategoryID(null)
                setValue('mainCategoryName', null)
                queryClient.invalidateQueries('categorylist')
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })

    function handleMainCategoryAddEdit(data) {
        const { mainCategoryName } = data
        try {
            mutation.mutate({ mainCategoryName })
        } catch (error) {
            console.log(error, 'Error')
        }
    }

    return (
        <div
        className=' admin-card'
            id="categorymodal001"
            name="categorymodal"
            aria-label="modal_cateogry"
        >
            <div class="head">
                <h2> {categoryID ? ' Edit' : ' Add'} Category</h2>
            </div>
            <div className="admin-form-body">
                <form onSubmit={handleSubmit(handleMainCategoryAddEdit)}>
                        <InputControl
                            autoFocus={true}
                            label="category Name"
                            name="mainCategoryName"
                            register={register}
                            reset={reset}
                            error={errors?.mainCategoryName?.message}
                        />
                        <button type="submit" className="solid-red-btn">
                            Save
                        </button>
                 
                </form>
            </div>
        </div>
    )
}
//#endregion
